import { render } from "./CharlaCompare.vue?vue&type=template&id=54db64f5&scoped=true"
import script from "./CharlaCompare.vue?vue&type=script&lang=js"
export * from "./CharlaCompare.vue?vue&type=script&lang=js"

import "./CharlaCompare.vue?vue&type=style&index=0&id=54db64f5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54db64f5"]])

export default __exports__